<template>
  <div>
    <div class="homework-content-info">
      <!-- HOMEWORK COUNT AND FILTER ROW -->

      <div class="count-filter-row">
        <!-- HOMEWORK COUNT -->

        <div class="count font-weight-bold color_grey_dark">
          {{ getHomeworks }}
        </div>
        <!-- FILTER -->
        <div
          v-if="false"
          class="filter color_text d-flex justify-content-end align-items-center pointer"
        >
          <div>Filter</div>
          <span class="icon-caret-fill-down font-9 ml-2"></span>
        </div>
      </div>
    </div>

    <!-- CONTENT CARD COMPONENT -->
    <div class="content-container mb-5" v-if="homeworks.length > 0">
      <HomeworkCard
        :id="homework.id"
        :date="homework.close_date"
        :title="homework.title"
        :total_questions="Number(homework.questionCount)"
        :submitted_students="Number(homework.submitted_students)"
        :expected_students="Number(homework.expected_students)"
        :subject="homework.subject.name"
        :status="homework.expiry_status"
        :progress_bar="homework.completion.toString()"
        :homework_data="homework"
        :class_id="homework.class_id"
        :tag="homework.tag"
        v-for="homework in homeworks"
        :key="homework.id"
        :tab="tab"
        :review_status="homework.review_status"
        @attach-questions="attachQuestions(homework)"
        @view-questions="viewQuestions(homework)"
        @manage-questions="manageQuestions(homework.id)"
        @update-homework="$emit('show-alert', 'Update', homework.id)"
        @manage-dates="$emit('show-alert', 'Extend', homework.id)"
        @restart-homework="$emit('show-alert', 'Restart', homework.id)"
        @delete-homework="$emit('show-alert', 'Delete', homework.id)"
      />
    </div>

    <!-- PAGINATION COMPONENT -->
    <div class="position-relative" style="top: -40px">
      <Pagination
        v-if="pagination && getPagination.pageCount > 1"
        :paging="getPagination"
        @navigatePage="$emit('switchPage', $event)"
      />
    </div>
    <!-- PAGINATION COMPONENT -->
  </div>
</template>

<script>
import { EXTERNAL_URL } from "@/var";
import HomeworkCard from "@/components/classComps/homework/HomeworkCard";

export default {
  name: "ContentInfo",

  props: ["homeworks", "tab", "pagination"],

  components: {
    HomeworkCard,
    Pagination: () =>
      import(
        /* webpackChunkName: "Pagination" */
        "@/components/globalComps/Pagination"
      ),
  },

  computed: {
    getHomeworks() {
      if (this.homeworks)
        return `${this.homeworks.length} Assessment${
          this.homeworks.length > 1 ? "s" : ""
        }`;
      else return false;
    },

    getPagination() {
      return this.pagination;
    },
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      manage_date_modal: false,
      update_assessment_modal: false,
    };
  },

  mounted() {
    localStorage.removeItem("homework");
  },

  methods: {
    toggleAssessmentDateModal() {
      this.manage_date_modal = !this.manage_date_modal;
    },

    toggleUpdateAssessmentModal() {
      this.update_assessment_modal = !this.update_assessment_modal;
    },

    getAccountType() {
      return this.$route.path.split("/")[1];
    },

    setCurrentHomework(homework) {
      let homework_content = {
        id: homework.id,
        title: homework.title,
        subject_id: homework.subject.id,
        global_class_id: this.$store.state.teacherClass.currentClass
          .global_class_id,
        class_id: homework.class_id,
        questionCount: homework.questionCount,
        close_date: homework.close_date,
        tag: homework.tag,
        open_date: homework.open_date,
      };

      localStorage.setItem("homework", JSON.stringify(homework_content));
      this.$store.commit("SET_CURRENT_HOMEWORK", homework_content);
    },

    viewQuestions(homework) {
      this.setCurrentHomework(homework);

      setTimeout(() => {
        // REDIRECT TO LMS
        location.href = EXTERNAL_URL("lms", `/manage-questions/${homework.id}`);

        // this.$router.push({
        //   name:
        //     this.getAccountType() === "teacher"
        //       ? "ManageTeacherAssessment"
        //       : "ManageScholAssessment",
        //   query: {
        //     action: "populated",
        //     assessment_id: homework.id,
        //   },
        // });
      }, 500);
    },

    attachQuestions(homework) {
      this.setCurrentHomework(homework);

      // clear existing questions from persisted storage, if present
      localStorage.removeItem("questions"); // don't remove once it has been pushed

      setTimeout(() => {
        // REDIRECT TO LMS
        location.href = EXTERNAL_URL("lms", `/select-question/${homework.id}`);
        // this.$router.push({
        //   name:
        //     this.getAccountType() === "teacher"
        //       ? "TeacherContentLibrary"
        //       : "SchoolContentLibrary",
        //   query: {
        //     action: "new",
        //     assessment_id: homework.id,
        //   },
        // });
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.homework-content-info {
  margin-top: 25px;
  margin-bottom: 40px;

  @include breakpoint_max(md) {
    margin-bottom: 90px;
  }

  @include breakpoint_max(sm) {
    margin-top: 20px;
    margin-bottom: 80px;
  }
}

.count-filter-row {
  margin-bottom: 0px;
  @include flex_row_between_nowrap;

  .count {
    font-size: 14px;
    line-height: 19px;

    @include breakpoint_max(sm) {
      font-size: 12.5px;
      font-weight: 600 !important;
    }
  }

  .filter {
    margin-right: 10px;
    font-size: 12px;
    line-height: 16px;
  }
}

.content-container {
  position: relative;
  top: -30px;

  @include breakpoint_max(md) {
    top: -60px;
  }
}
</style>
